/* ===========================================================================
© Mesomorphic Ltd
============================================================================= */
export default function setupUnsavedWarning($form) {
  if ($form.length === 0) return;

  let isDirty = false;
  let isSubmitting = false;

  function warnIfDirty(event) {
    if (isDirty && !isSubmitting) {
      event.preventDefault();
      event.returnValue = '';
      return ''; // satisfies `consistent-return`
    }
    return undefined;
  }

  function checkTurbolinks(event) {
    if (isDirty && !isSubmitting) {
      // Using native confirm for unsaved changes warning.
      // This is expected UX for browser navigation protection.
      // eslint-disable-next-line no-alert
      const leave = window.confirm('You have unsaved changes. Are you sure you want to leave this page? Press OK to leave or Cancel to stay.');
      if (!leave) event.preventDefault();
    }
  }

  // Delay attaching unsaved changes listener to allow sorting/select2 to settle.
  // WARNING: This approach may cause flaky system tests if timing is too tight.
  setTimeout(() => {
    $form.on('change input', ':input', () => {
      isDirty = true;
    });
  }, 1000);

  $form.find('[type="submit"]').on('click', () => {
    isSubmitting = true;
  });

  $form[0].addEventListener('submit', () => {
    isSubmitting = true;
  }, { once: true });

  window.addEventListener('beforeunload', warnIfDirty);
  document.addEventListener('turbolinks:before-visit', checkTurbolinks);

  const cleanup = () => {
    isDirty = false;
    window.removeEventListener('beforeunload', warnIfDirty);
    document.removeEventListener('turbolinks:before-visit', checkTurbolinks);
    document.removeEventListener('turbolinks:load', cleanup);
  };

  document.addEventListener('turbolinks:load', cleanup);
}
